import { EDITOR } from '../../providers/param/registry-keys.js';
import { ParamRegistry } from '../../registries/param-registry.js';
import { PreHandlers } from '../../registries/pre-handler-registry.js';

/**
 * 获得当前激活的编辑器
 *
 * @public
 * @decorator
 */
function Editor() {
    return ParamRegistry.decorate(EDITOR);
}
PreHandlers.set(EDITOR, ({ context, runner }) => { var _a; return (_a = runner.context.editor) !== null && _a !== void 0 ? _a : context.editor; });

export { Editor };
//# sourceMappingURL=editor.js.map
